import errorModalTemplate from './errorModal.html';

const ERROR_MODAL_TEMPLATE_URL = 'assets/javascripts/xchelper/services/errorModal.html';

export default function errorModal($uibModal, $templateCache, $window, $rootScope) {

  $templateCache.put(ERROR_MODAL_TEMPLATE_URL, errorModalTemplate);
  if ($window.appVersion) {
    $templateCache.put(ERROR_MODAL_TEMPLATE_URL + '?v=' + $window.appVersion, errorModalTemplate);
  }

  let modalInstance;

  let _showErrorModal = function (errorMessage, showSwitchModal = false, showLogoutButton = !showSwitchModal, switchConfirmationMessage = 'SWITCH_TO_CTI_MOD') {
    if (!$rootScope.fatalErrorModalOpen) {
      $rootScope.fatalErrorModalOpen = true;
      modalInstance =  $uibModal.open({
        templateUrl: ERROR_MODAL_TEMPLATE_URL,
        size: 'sm',
        windowClass: 'fatal-error',
        backdrop: false,
        controller: 'FatalErrorController',
        resolve: {
          errorMessage: function () {
            return errorMessage;
          },
          showSwitchModal: function () {
            return showSwitchModal;
          },
          showLogoutButton: function () {
            return showLogoutButton;
          },
          switchConfirmationMessage: function () {
            return switchConfirmationMessage;
          }
        }
      });
      modalInstance.closed.then(()=>{$rootScope.fatalErrorModalOpen = false;});
    }
    return modalInstance;
  };

  return {
    showErrorModal: _showErrorModal
  };
}
